export const headCellsVideo = [
    { id: 'bulk', numeric: false, disablePadding: true, label: '', sorted: false, size: "small"},
    { id: 'thumbnail', numeric: false, disablePadding: true, label: 'Thumbnail', sorted: false},
    { id: 'name', numeric: false, disablePadding: false, label: 'Title', sorted: true },
    { id: 'categories', numeric: false, disablePadding: false, label: 'Categories', sorted: false },
    { id: 'status', numeric: false, disablePadding: false, label: 'Status', sorted: false },
    { id: 'created_at', numeric: false, disablePadding: false, label: 'Uploaded', sorted: true },
];
